module.exports = __webpack_public_path__ + "static/media/50.9d0f899c.jpg";